import type { useTranslations } from 'next-intl'
import { z } from 'zod'

export function getRegisterFormSchema({
  t,
}: {
  t: ReturnType<typeof useTranslations>
}) {
  return z.object({
    email: z.string().min(2, {
      message: t('inputs.email.minCharacters'),
    }),
    password: z
      .string()
      .min(8, { message: t('inputs.password.minCharacters') })
      .refine(
        val => /[A-Z]/.test(val),
        t('inputs.password.missing.uppercase'),
      )
      .refine(
        val => /[a-z]/.test(val),
        t('inputs.password.missing.lowercase'),
      )
      .refine(val => /\d/.test(val), t('inputs.password.missing.number'))
      .refine(
        val => /[#?!@$%^&*-]/.test(val),
        t('inputs.password.missing.specialChar'),
      ),
    userName: z.string().min(2, {
      message: t('inputs.username.minCharacters'),
    }),
  })
}

export type RegisterFormValues = z.infer<
  ReturnType<typeof getRegisterFormSchema>
>
